import { apiInstance } from "./api"

const endpoint = "/branch"

export const getBranches = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}`)

  return response.data
}

export const changeBranchAutoConfirm = async (branchId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/auto-confirm/${branchId}`, data)

  return response.data
}